import {cast, Instance, SnapshotOut, types} from "mobx-state-tree"
import { Timestamp } from "firebase/firestore";

/**
 * Rick and Morty character model.
 */
export const StaffModel = types.model("Staff").props({
  id: types.string,
  businessId: types.string,
  projectIds: types.array(types.string),
  role: types.string,
  name: types.string,
  email: types.string,
  isDeleted: types.boolean
})

type StaffType = Instance<typeof StaffModel>
export interface Staff extends StaffType {}
type StaffSnapshotType = SnapshotOut<typeof StaffModel>
export interface StaffSnapshot extends StaffSnapshotType {}

export const staffFromJson = (docData) => {

  console.log("staffFromJson", docData)

  return {
    id: docData.id as string,
    businessId: docData.businessId as string,
    projectIds:docData.projectIds as string[],
    role: docData.role as string,
    name: docData?.name as string,
    email: docData?.email as string,
    isDeleted: docData?.isDeleted
  }
}
